export default "__VITE_ASSET__DGIWYjna__"